import React from "react";
import { Button, Grid, Paper } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import ReportDefinitionDeletionDialog from "./ReportDefinitionDeletionDialog";
import ReportDefinitionsList from "./ReportDefinitionsList";
import ReportDefinitionFormDialog from "./ReportDefinitionFormDialog";
import { ReportExecutionOrder } from "../../../types/ReportExecutionOrder";
import { useAddReportDefinitionsToTestSequence } from "../../../projectManagementMutations";

const ReportDefinitionsPicker = ({
  rsdProcedureDefinitions,
  onAddItem,
  onEditItem,
  onDeleteItem,
}: {
  rsdProcedureDefinitions: ReportExecutionOrder[];
  onAddItem: (newProcedureDefinition: ReportExecutionOrder) => void;
  onEditItem: (
    oldProcedureDefinition: ReportExecutionOrder,
    newProcedureDefinition: ReportExecutionOrder
  ) => void;
  onDeleteItem: (procedureDefinitionToDelete: ReportExecutionOrder) => void;
}) => {

  const [procedureDefinitionDialogIsOpen, setProcedureDefinitionDialogIsOpen] =
    React.useState(false);
  const [
    deletionConfirmationDialogIsOpen,
    setDeletionConfirmationDialogIsOpen,
  ] = React.useState(false);
  const [editingMode, setEditingMode] = React.useState(false);
  const [procedureDefinitionToDelete, setProcedureDefinitionToDelete] =
    React.useState<ReportExecutionOrder>();
  const [procedureDefinitionToEdit, setProcedureDefinitionToEdit] =
    React.useState<ReportExecutionOrder>();

  const handleOpenCreationDialog = () => {
    setEditingMode(false);
    setProcedureDefinitionDialogIsOpen(true);
  };

  const handleOpenEditionDialog = (
    procedureDefinition: ReportExecutionOrder
  ) => {
    setEditingMode(true);
    setProcedureDefinitionToEdit(procedureDefinition);
    setProcedureDefinitionDialogIsOpen(true);
  };

  const handleCloseProcedureDefinitionDialog = () => {
    setProcedureDefinitionDialogIsOpen(false);
  };

  const handleOpenDeletionConfirmationDialog = (
    procedureDefinition: ReportExecutionOrder
  ) => {
    setProcedureDefinitionToDelete(procedureDefinition);
    setDeletionConfirmationDialogIsOpen(true);
  };

  const handleCloseDeletionConfirmationDialog = () => {
    setDeletionConfirmationDialogIsOpen(false);
  };

  return (
    <React.Fragment>
      {/* This is the list of Report Definition */}
      <Grid container direction="row" justifyContent="center">
        <Paper>
          <div style={{ margin: 16 }}>
            <ReportDefinitionsList
              procedureDefinitions={rsdProcedureDefinitions}
              onClickEditItem={handleOpenEditionDialog}
              onClickDeleteItem={handleOpenDeletionConfirmationDialog}
            />
            {/*<Grid item container justifyContent="center" xs={12}>
              <Grid item>
                <Typography variant="h6">
                  List of Picked Procedure Definitions
                </Typography>
              </Grid>
            </Grid>

            <Grid item container justifyContent="center" xs={12}>
              <Grid item>
                {tsdProcedureDefinitions &&
                tsdProcedureDefinitions.length !== 0 ? (
                  <List>
                    {tsdProcedureDefinitions
                      .sort(
                        (
                          firstItem: ProcedureExecutionOrder,
                          secondItem: ProcedureExecutionOrder
                        ) => {
                          if (firstItem && secondItem) {
                            return (
                              firstItem.execution_group_number -
                              secondItem.execution_group_number
                            );
                          }

                          return 0;
                        }
                      )
                      .map((procedureDefinition) => (
                        <ProcedureDefinitionItem
                          procedureDefinitionItem={procedureDefinition}
                          onClickEditItem={(procedureDefinitionItem) => {
                            handleOpenEditionDialog(procedureDefinitionItem);
                          }}
                          onClickDeleteItem={(procedureDefinitionItem) => {
                            handleOpenDeletionConfirmationDialog(
                              procedureDefinitionItem
                            );
                          }}
                        />
                      ))}
                  </List>
                ) : (
                  <p>No Picked Procedure Definitions yet!</p>
                )}
              </Grid>
            </Grid>*/}

            <Grid item container justifyContent="center" xs={12}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenCreationDialog}
                >
                  <AddIcon />
                </Button>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Grid>

      {/* This is the dialog to create and add a ReportDefinition */}
      <ReportDefinitionFormDialog
        dialogIsOpen={procedureDefinitionDialogIsOpen}
        onCloseDialog={handleCloseProcedureDefinitionDialog}
        editingInfo={{
          editingMode,
          procedureDefinition: procedureDefinitionToEdit!,
        }}
        onSubmitProcedureDefinition={(
          existingProcedureDefinition,
          procedureDefinition
        ) => {
          if (editingMode && existingProcedureDefinition) {
            onEditItem(existingProcedureDefinition, procedureDefinition);
          } else {
            onAddItem(procedureDefinition);
          }
        }}
      />

      {/*This is the dialog to delete a ProcedureDefinition*/}
      <ReportDefinitionDeletionDialog
        dialogIsOpen={deletionConfirmationDialogIsOpen}
        onClose={handleCloseDeletionConfirmationDialog}
        reportDefinitionToDelete={procedureDefinitionToDelete!}
        onConfirmDeletion={(procedureDefinitionToDelete) => {
          onDeleteItem(procedureDefinitionToDelete);
          handleCloseDeletionConfirmationDialog();
        }}
      />
    </React.Fragment>
  );
};

export default ReportDefinitionsPicker;
